export default __webpack_public_path__ + "static/section_4_details_2-5bf7d672c5a29b89aa63385b5188c588.png";